import { Typography } from '@mui/material';
import { useHatm } from '../../context/HatmContext';
import { formatDate } from '../../utils/helpers';
import { HeaderSection } from '../../styles/hatm.styles';
import ShareButton from './ShareButton';

export default function HatmHeader({ hatmId }) {
  const { state } = useHatm();

  if (!state) return null;

  const created = formatDate(state.date);
  const endDate = formatDate(state.endDate);

  return (
    <HeaderSection className="hatm-header-section">
      <Typography variant="h4" gutterBottom>
        {state?.title}
      </Typography>
      
      <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
        {state?.creatorName} tarafından {created} günü oluşturuldu. 
        Katılmak için son gün {endDate}. 
        Bu hatimi arkadaşlarınla
        <ShareButton hatmId={hatmId} />
      </Typography>
    </HeaderSection>
  );
} 